import { Check, Film } from "lucide-react";
import { PROJECTS } from "@/lib/site";

export const CurrentProject = () => {
  const p = PROJECTS.current;

  return (
    <section
      id="zero-to-one"
      data-testid="current-project-section"
      className="relative scroll-mt-nav py-28 md:py-36 bg-[#050505] overflow-hidden"
    >
      <div className="absolute inset-0 pointer-events-none opacity-40">
        <div className="absolute top-1/3 -left-40 w-[520px] h-[520px] rounded-full bg-[#D4AF37]/10 blur-[140px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-10">
        <div className="flex items-baseline justify-between mb-12">
          <div>
            <p className="text-xs tracking-[0.3em] uppercase text-[#2DD4BF]">03 · Present Project</p>
            <h2 className="font-serif text-4xl md:text-5xl text-white mt-3">In Production Now</h2>
          </div>
          <span className="hidden md:flex items-center gap-2 text-xs tracking-[0.25em] uppercase text-[#D4AF37]">
            <Check size={14} /> First Schedule Completed
          </span>
        </div>

        <div className="grid lg:grid-cols-12 gap-10 items-stretch">
          <div className="lg:col-span-5">
            <div className="relative rounded-3xl overflow-hidden border border-[#D4AF37]/30 hover-lift group">
              <img
                src={p.poster}
                alt={p.title}
                className="w-full h-auto object-cover"
                data-testid="zero-to-one-poster"
              />
              <div className="absolute top-4 left-4 px-3 py-1.5 rounded-full bg-black/70 backdrop-blur text-[10px] tracking-[0.25em] uppercase text-[#D4AF37] border border-[#D4AF37]/40">
                Current · 2025
              </div>
            </div>
          </div>

          <div className="lg:col-span-7 flex flex-col justify-between">
            <div>
              <p className="text-xs tracking-[0.25em] uppercase text-[#2DD4BF]">A Film by Nagaveni Santhosha</p>
              <h3
                data-testid="zero-to-one-title"
                className="font-serif text-6xl md:text-7xl lg:text-8xl text-white mt-3 leading-none"
              >
                Zero <span className="italic text-gradient-gold">to</span> One
              </h3>
              <p className="font-serif italic text-xl text-slate-300 mt-3">{p.subtitle}</p>

              <p className="text-slate-300 text-base md:text-lg leading-relaxed mt-8 max-w-2xl">
                {p.synopsis}
              </p>
            </div>

            <div className="mt-10">
              <p className="text-xs tracking-[0.3em] uppercase text-slate-400 mb-4">Releasing In</p>
              <div className="flex flex-wrap gap-2">
                {p.languages.map((l) => (
                  <span key={l} className="lang-pill" data-testid={`lang-pill-${l.toLowerCase()}`}>
                    {l}
                  </span>
                ))}
              </div>

              <div className="mt-10 grid grid-cols-3 gap-4">
                {[
                  { k: "Schedule 1", v: "Completed", done: true },
                  { k: "Schedule 2", v: "In Prep", done: false },
                  { k: "Post‑Production", v: "Planning", done: false },
                ].map((s) => (
                  <div
                    key={s.k}
                    className={`glass-card rounded-xl p-4 ${
                      s.done ? "border-[#2DD4BF]/40" : ""
                    }`}
                  >
                    <div className="flex items-center gap-2 mb-2">
                      {s.done ? (
                        <Check size={14} className="text-[#2DD4BF]" />
                      ) : (
                        <Film size={14} className="text-slate-500" />
                      )}
                      <span className="text-[10px] tracking-[0.25em] uppercase text-slate-400">
                        {s.k}
                      </span>
                    </div>
                    <p className={`font-serif text-lg ${s.done ? "text-[#2DD4BF]" : "text-white"}`}>
                      {s.v}
                    </p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
